<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2Z" fill="url(#paint0_linear)"/>
<path d="M13.3535 14.6505H15.9415L16.348 12.0215H13.3535V10.5845C13.3535 9.49252 13.7105 8.52402 14.732 8.52402H16.3735V6.23002C16.085 6.19102 15.475 6.10602 14.3225 6.10602C11.9155 6.10602 10.5045 7.37702 10.5045 10.273V12.022H8.03V14.651H10.504V21.877C10.994 21.95 11.4905 22 12 22C12.4605 22 12.91 21.958 13.3535 21.898V14.6505Z" fill="white"/>
<defs>
<linearGradient id="paint0_linear" x1="4.9965" y1="4.9965" x2="20.3075" y2="20.3075" gradientUnits="userSpaceOnUse">
<stop stop-color="#2AA4F4"/>
<stop offset="1" stop-color="#007AD9"/>
</linearGradient>
</defs>
</svg>
